import React, { useEffect, useState } from "react";
import Card from "../../ui/Card";
import Space from "../../ui/Space";
import VirtualTable from "../../ui/VirtualTable";
import { pubCall } from "../../utils/PubSub";
import { bm_date } from "../../utils/Utils";
import { KBD } from "../../utils/Keybindings";
import { listen } from "../../hooks/Listener";
export default function HeldCheck(props) {

    const { controller = "", route = "", data = [], callback = () => { } } = props;


    const row_key = "posh_id";

    const newRow = {
        posh_id: "new",
        type: "",
        invoice: "",
        date: "New...",
        purchase_order: ""
    };


    const [selected, setSelected] = useState(newRow);
    const [items, setItems] = useState([]);
    const [align, setAlign] = useState("auto")
    const [loading, setLoading] = useState(false);



    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: () => callback(false) },
            { key: KBD.ENTER, action: () => (selected?.posh_id === "new") ? callback(false) : callback(selected) },
        ];

        return listen(controller, route, actions, () => { }, []);
    }, [controller, route, selected]);


    const next = (_rows = 1) => {
        setAlign("auto");

        const index = rows.findIndex(
            item => item?.[row_key] === selected?.[row_key]
        );

        setSelected(rows[Math.min(index + _rows, rows.length - 1)]);
    };

    const prev = (_rows = 1) => {
        setAlign("auto");

        const index = rows.findIndex(
            item => item?.[row_key] === selected?.[row_key]
        );

        setSelected(rows[Math.max(index - _rows, 0)]);
    };



    const columns = [
        { key: "date", align: "left", title: <>InvDate</>, width: 100, grow: false, render: (e) => { return (e === "New...") ? e : bm_date(e) } },
        { key: "type", align: "left", title: <>T</>, width: 30, grow: false },
        { key: "invoice", align: "left", title: <>Inv#</>, width: 100, grow: false },
        { key: "purchase_order", align: "left", title: <>PO#</>, width: 100, grow: true },
    ]

    const item_columns = [
        { key: "quantity", align: "right", title: <>Qty</>, width: 40, grow: true },
        { key: "title", align: "left", title: <>Title</>, width: 100, grow: true },
        { key: "cust_po", align: "left", title: <>PO#</>, width: 100, grow: true },
        { key: "date", align: "left", title: <>Entered</>, width: 100, grow: false, render: (e) => { return bm_date(e) } },
    ]



    const fetchItems = () => {

        setItems([])
        setLoading(true);
        pubCall("point_of_sale.getInitialItem", { sort: "id", invoice: selected?.invoice, limit: 40 }, (_s, _r) => {
            if (_s) {
                setItems(_r.rows_next);
            }
            setLoading(false)
        })
    }

    useEffect(fetchItems, [selected])

    const rows = [newRow, ...data];


    const handleEnter = (_selected = selected) => {
        if (_selected?.posh_id === "new") {
            callback(false);
        } else {
            callback(selected);
        }
    };


    return (
        <div style={{ "width": "800px" }}>
            <div className="shim" /> <div className="shim" />
            <small>
                There are Held transactions for this customer. [enter] to slect one or press [Y]es on "New"
            </small>
            <div className="shim" /> <div className="shim" />
            <Space>
                <VirtualTable
                    controller={controller}
                    onRowClick={(item, event, index) => { 
                        setSelected(item);
                        if(item?.posh_id === "new"){
                            callback(false)
                        } else {
                            callback(item)
                        }
                    }}
                    next={next}
                    prev={prev}
                    align={align}
                    row_key={row_key}
                    current={selected}
                    data={rows}
                    columns={columns}
                    width={1100}
                    offset={430}
                    route={route}
                />

                <VirtualTable
                    controller={controller}
                    align={align}
                    edit={false}
                    loading={loading}
                    row_key={row_key}
                    data={items}
                    columns={item_columns}
                    width={1100}
                    offset={430}
                    route={route}
                />

            </Space>

            {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
        </div>
    )
}